export const isBadImpData = (imp) => {
  if (imp.pg_provider === 'html5_inicis' && imp.currency !== 'KRW') return true;
  if (imp.pg_provider === 'naverpay' && imp.currency !== 'KRW') return true;
  return false;
};
